import { render } from "./Work.vue?vue&type=template&id=2daf79f7&scoped=true"
import script from "./Work.vue?vue&type=script&lang=js"
export * from "./Work.vue?vue&type=script&lang=js"

import "./Work.vue?vue&type=style&index=0&id=2daf79f7&lang=scss&scoped=true"

import exportComponent from "/data/jenkins/data/workspace/gym-official-web_prod/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2daf79f7"]])

export default __exports__